// ----------------------------------------------------------------------

import { de } from 'date-fns/locale';

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const en = {
  no: `No`,
  select_country_code: `Select Country Code`,
  balance: `Balance`,
  loading: `Loading...`,
  requirement: `Requirement`,
  deposit_from_bank: `Deposit From Bank`,
  game: `Game`,
  games: `Games`,
  sport: `Sport`,
  center: `Center`,
  mines: `MINES`,
  crash: `CRASH`,
  lucky_colour: `LUCKY COLOUR`,
  dice: `DICE`,
  limbo: `LIMBO`,
  lucky_gift: `LUCKY GIFT`,
  all_games: `All Games`,
  game_history: `Game History`,
  coupon_code: `Coupon Code`,
  telegram: `Telegram`,
  customer_service: `Customer Service`,
  player: `Player`,
  winner: `Winner`,
  all_bets: `All Bets`,
  my_bets: `My Bets`,
  name: `Name`,
  time: `Time`,
  bet_amount: `Bet Amount`,
  prediction: `Prediction`,
  payout: `Payout`,
  login: `Login`,
  register: `Register`,
  username_placeholder: `Username`,
  please_input_your_x: `Please Input Your {{x}}`,
  affiliate_referral: `Affiliate / Referral ID (OPTIONAL)`,
  captcha: `CAPTCHA`,
  forgot_password: `Forgot Password`,
  minor_note: `To visit this site, make sure you are over 18 and agree`,
  terms_of_service: `Terms of Service`,
  by_signing_in: 'By Signing In or Signing Up, you agree with our',
  dont_have_account: `Don't have an account?`,
  sign_up: `Register`,
  username: `Username`,
  email: `Email`,
  full_name: `Full Name`,
  no_bank_accounts_added: `No bank account added`,
  confirm_18: `By clicking the Register button, I hereby acknowledge that I am above 18 years old and have read and accepted your`,
  already_have_account: `Already have an account?`,
  share: `Share`,
  deposit: `Deposit`,
  promos: `Promos`,
  promo: `Promo`,
  acc: `Acc`,
  bonus: `Bonus`,
  app: `App`,
  load_more: `Load More`,
  details: `Details`,
  helps: `HELPS`,
  kyc_policy: `KYC Policy`,
  privacy_policy: `Privacy Policy`,
  responsible_gaming: `Responsible gaming`,
  terms_and_condition: `Terms and Condition`,
  faq: `FAQ`,
  about_us: `ABOUT US`,
  about_us_profile: `About Us`,
  amount: `Amount`,
  minimum: `Min`,
  maximum: `Max`,
  enter_amount: `Enter Amount`,
  extra: `Extra`,
  deposit_bonus: `Deposit Bonus`,
  do_not_participate: `Do not participate in promotions`,
  payment_problem: `Payment Problem`,
  click_for_help: `Click for help`,
  deposit_notes: `Deposit Notes`,
  available_balance: `Available Balance`,
  withdraw: `Withdraw`,
  withdrawal: `Withdrawal`,
  withdrawal_notes: `Withdrawal Notes`,
  withdrawal_note1: `Number of withdrawals in current`,
  withdrawal_note1_1: `vip`,
  withdrawal_note2: `Withdrawal fee:`,
  havent_login_yet: `Haven’t login yet...`,
  login_register_now: `Login/Register Now!`,
  min: `Min:`,
  max: `Max:`,
  opening_times: `Opening times:`,
  withdrawal_note3: `1.Fastest withdrawal time within 10 minutes`,
  withdrawal_note4: `2.Make sure your withdrawal information is accurate, if the withdrawal information is wrong, it may cause your funds to lose.`,
  withdrawal_note5: `3.Please feel free to contact us if you have any questions.`,
  notifications: `Notifications`,
  invalid_x: `Invalid {{x}}`,
  captcha_not_match: `Captcha Does Not Match`,
  invalid_x_must_be_atleast_y_characters: `Invalid {{x}}, must be atleast {{y}} characters`,
  x_is_required: `{{x}} is required`,
  phone_number: 'Phone Number',
  phone_num_x_max: `Phone Number maximum {{x}} digits`,
  email_sent: `Email sent, please check your email.`,
  enter_valid_email: `Please enter a valid email.`,
  confirm: `Confirm`,
  password_atleast_6_characters: `Password must be atleast 6 characters.`,
  password_reset_success: `Password reset success!.`,
  new_password: `New Password`,
  bank: 'Bank',
  bank_transfer: `Bank Transfer`,
  transfer: `Transfer`,
  more: `More`,
  bank_name: `Bank Name`,
  account_name: `Account Name`,
  account_number: `Account Number`,
  pix_number: `PIX Number`,
  drop_or_select: `Drop or Select file`,
  drop_files_here: `Drop files here`,
  transfer_to: `Transfer To`,
  upload_receipt: `Upload Receipt`,
  select_bonus: `Select Bonus`,
  no_promotion: `No Promotion`,
  please_upload_receipt: `Please upload receipt`,
  bank_account: `Bank Account`,
  add_account: `Add Account`,
  account_holder_name: `Account Holder Name`,
  name_of_the_account_holder: `Name of the Account Holder`,
  fill_in_bank_account: `Fill in Bank Account`,
  withdraw_information: `Withdraw Information`,
  note: `Note`,
  amount_withdrawn: `Amount withdrawn`,
  amount_no_exceed_balance: `Withdraw Amount should not exceed the available balance`,
  minimum_withdraw_amount_is_x: `Minimum Withdraw amount is {{x}}`,
  transaction_history: `Transaction History`,
  date_from: `Date From`,
  date_to: `Date To`,
  account_name_must_be_4: `Account Name must be greater than 4 in length`,
  account_number_must_be_x: `Account number must be 10-14 in length`,
  minimum_length_is_x: `Minimum length is {{x}}`,
  maximum_length_is_x: `Maximum length is {{x}}`,
  payment_method: `Payment Method`,
  mode: `Mode`,
  no_bank_account: `You do not have any account to withdraw to, Add now`,
  please_select_bank: `Please select a Bank Account`,

  bet_history: `Bet History`,
  game_provider: `Game Provider`,
  bet_count: `Bet Count`,
  win_loss: `Win/Loss`,
  rebate: `Rebate`,
  turnover: `Turnover`,
  game_category: `Game Category`,

  you_have_x_unread_messages: `You have {{x}} unread messages`,
  deposit_amount_between_x_and_y: `Deposit amount must be between {{x}} and {{y}}`,
  minimum_amount_is_x_y: `Minimum amount is {{x}}{{y}}`,

  // all
  all: `All`,
  title: `Title`,
  date: `Date`,
  type: `Type`,
  status: `Status`,
  remark: `Remark`,
  category: `Category`,
  please_select_x: `Please select {{x}}`,
  save: `Save`,

  change_password: `Change Password`,
  current_password: `Current Password`,
  confirm_password: `Confirm New Password`,
  submit: `Submit`,
  password_changed: `Password Changed`,
  x_must_be_y_characters: `{{x}} must be at least {{y}} characters`,
  reset_password: `Reset Password`,
  casino: `Casino`,
  slots: `Slots`,
  slot: `Slot`,
  live_casino: `Live Casino`,
  mobile_slot: `Mobile Slot`,
  fishing: `Fishing`,
  sports: `Sports`,
  cards: `Cards`,
  clear: `Clear`,
  search: `Search`,
  new: `New`,
  logout: `Logout`,
  choose_date: `Choose Date`,
  select_both_date: `Select both Date From and To`,
  from: `From`,
  to: `To`,
  apply: `Apply`,
  promotions: `Promotions`,
  learn_more: `LEARN MORE`,
  password_doesnt_match: `Password doesn't match`,
  cancel: `Cancel`,
  confirm_to_pay: `Confirm To Pay`,
  deposit_amount: `Deposit Amount`,
  loading_please_wait: `Loading, Please Wait`,
  account: `Account`,
  profile: `Profile`,
  bank_list: `Bank List`,
  in_maintenance: `In Maintenance`,
  birthday: `Birthday`,
  birthday_bonus: `Birthday Bonus`,
  referral_code: `Referral Code`,
  referral: `Referral`,
  my_referral: `My Referral`,
  my_claim: `My Claim`,
  claim_profit: `CLAIM PROFIT`,
  available_profit: `Available Profit`,
  claimed_profit: `Claimed Profit`,
  all_time_profit: `All Time Profit`,
  referral_note_on_x: `Earn profit every time your friends playing on {{x}}`,
  tier: `Tier`,
  commission: `Commission`,
  referred_member: `Referred Member`,
  profit_earned: `Profit Earned`,
  account_information: `Account Information`,
  invite_friends: `Invite Friends`,
  how_it_work: `How it work?`,
  invite_note: `Get exclusive referral bonuses when your friend signs up using your referral code!`,
  share_via: `Share via`,
  referral_link: `Referral Link`,
  total_profit: `Total Profit`,
  copied: `Copied`,
  nothing_to_claim: `Nothing to claim`,
  claim_history: `Claim History`,
  downline: `My Downline`,
  last_x_digit_bank_ref_number: `Last {{x}} digit of Bank Ref number`,
  bank_ref_number_validation_x: `Bank Ref Number is required and must be {{x}} character length`,
  sort: 'Sort',
  login_directly: `Login directly with`,
  our_game_provides: `OUR GAME PROVIDERS`,
  we_accept_below_bank: `We Accept Below Banks`,
  we_accept_payment_methods: `We Accept Payment Method`,
  refer_and_reward: `Refer & Reward`,
  linked_successfully_x: `Linked successfully with {{x}}! Please register your account for the first time`,
  more_x_of_y: `More {{x}}/{{y}}`,
  default: `Default`,
  promotion: `Promotion`,
  daily_mission: 'Daily Mission',
  agent: 'Agent',
  contact_us: 'Contact Us',
  download: 'Download',
  cash_claim: 'Cash Claim',
  demo: 'Demo',
  favorites: 'Favorites',
  popular: 'Popular',
  claim_bonus: `Claim Bonus`,
  insufficient_balance: `Insufficient Balance`,
  currently_displaying: 'Currently displaying {{x}} {{y}} games out of {{z}}',
  all_x: 'All {{x}}',
  no_results: 'No search results found',
  search_games: 'Search Games',
  please_scan_using_your: `Please scan using your`,
  vip_level: `VIP Level`,
  bonus_direct: `BONUS DIRECT`,
  rebate_level: `Rebate Level`,
  vip_header: `All bets placed on Slot Machines, Board and Card Games, Fishing, Videos, Sports and Lottery Games at Jit993 will be accumulated permanently. Valid bets = Permanent Income and Money Fortune!`,
  vip_example: `
  Example 1: Members who reach 1 Million in accumulated deposits, reach VIP Level 2, receive a bonus of R$210,and Rebate 3.50%, When they reach 6 Million in accumulated deposit, they reach VIP Level 3 and receive a bonus of R$800, with a Rebate 4%`,
  activity_rules: `Activity Rules:`,
  activity_rules_1: `1. It is necessary for all bonuses to have x3 Rollover to request the Withdrawal`,
  activity_rules_2: `2. Please claim the Rebate Bonus within the deadline, if you happen to be late, it will be considered abandonment;`,
  activity_rules_3: `3. Members' participation in activities is automatically counted by the system, if there is any objection, the result of Jit993's investigation will prevail;`,
  activity_rules_4: `4. If you forget your member Account/Password, please contact "24-hour Online Customer Service" to help you recover your account information;`,
  activity_rules_5: `5. Jit993 reserves the right to change, stop or cancel this promotion at any time.`,
  activity_rules_6: `6. Do not save free game , Buy free game`,
  activity_rules_7: `7. Can't combine with any bonus`,
  activity_rules_8: `8. Maximum Withdraw per Deposit is R$100.000.00`,
  event_instructions: 'Event Instructions',
  agent_p1: 'Share your unique link across apps and social media',
  agent_p2:
    'Facebook, Instagram, Tiktok, Telegram, WhatsApp, YouTube, among others, hurry up and invite everyone, members who register through your exclusive link will become your direct agents. But pay attention because the new members you invite must be genuine and valid.',
  agent_step1:
    'Get invitation friend the first deposit is successful, you can win a bonus of R$5. for example, if you invite 10 people for the first deposit, you can earn R$50. The more people you invite, the more bonuses you will receive. You can view your history and register on the promotion pageonuses and high commissions.',
  agent_step2:
    "If your guests bet R$1 or more, you can already enjoy high commission! You can earn up to 5% lifetime commission, and an invitation for life! The system will settle the previous day's commission at 7am the following day.",
  agent_step2_1: 'How to get: Login - Invitation promotion - Collect commission',
  agent_table1: 'Betting commission rates for slot, fishing and blockchain are as follows:',
  agent_table1_1: 'The customer topup 20 bet 200',
  person: 'person',
  agent_table2_title1: 'Member Betting',
  agent_table2_title2: 'Slot Game Only',
  agent_table2_example:
    'Example: You have 100 members, and the total real value of bets is estimated at 1 million reais per day. The commission you receive that day is: 1,000,000 x 1.20% 12,000 reais. A monthly income of 100,000 is super easy to achieve.',
  reminder: 'Reminder',
  agent_reminder:
    'A member account with the same IP, same device, name, bank card and other information can only participate once, and anyone who violates the rules will not benefit from this bonus. or the group will be confiscated and accounts will be permanently frozen',
  agent_step3_1:
    'The participation of members in activities is automatically counted by the system, if there is any objection, the result of the analysis carried out by Jit993 will prevail',
  agent_step3_2:
    'If you forget your member account/password, please contact our 24-hour customer service team to help you recover your account information',
  agent_step3_3: 'Jit993 reserves the right to change, interrupt or cancel the promotion at any time',
  agent_step3_4: 'Agent able to received the comission bonus is term of cash or credits in wallet',
  agent_step3_5: 'Do not save free game, Buy free game',
  agent_step3_6: "Can't combine with any bonus and deposit",
  agent_step3_7: 'Only available for Slot game',
  promo_concluded: 'Promo has concluded! Check back again tomorrow!',
  can_only_claim: 'Can only claim bonus between {{x}} to {{y}} {{z}} Time',
  please_login: 'Please Login first to claim the bonus!',
  back_to_home: 'Back to Home',
  bonus_claimed: 'Bonus Already Claimed!',
  wallet: 'Wallet',
  bank_bsb: `Bank BSB`,
  home: 'Home',
  pay_id: `PayID`,
  from_selected_promotion: 'from selected promotion',
  helpful_links: 'Helpful Links',
  platform: 'Platform',
  community: 'Community',
  support: 'Support',
  partnership_program: 'Partnership Program',
  help_center: 'Help Center',
  sports_policy: 'Sports Policy',
  aml_policy: 'AML Policy',
  level: 'Level',
  back: 'Back',
  dns: `DNS`,
  vip: `VIP`,
  daily_checkin: `Daily Check-in`,
  network_error: 'Network Error',
  we_have_sent_otp: 'We have sent an OTP to your phone number',
  your_otp_expire: 'Your OTP will expire in',
  didnt_receive: "Didn't receive the message?",
  send_again: 'Send Again',
  resend_again: 'Resend again in',
  invalid_verification: 'Invalid Verification Code!',
  otp_expired: 'OTP expired, please reenter your phone number and try again!',
  otp_expired_redirect: 'OTP expired! redirecting to login',
  captcha_check_failed: 'Captcha Check Failed!',
  verify_phonenumber: 'Verify Phone Number',
  send_otp: 'Send OTP',
  success_verification: 'Your Phone Number has been verified!',
  press_get_code: 'Press GET CODE Button To Receive Verification Code Via SMS',
  otp_sent: 'Verification Code Sent! Enter the verification code below to continue',
  get_code: 'Get Code',
  verify: 'Verify',
  verification_code: 'Verification Code',
  otp_not_found: 'OTP Function Not Found!',
  terms_n_conditions: `TERMS AND CONDITION`,
  the_activity_x_in: `The Activity {{x}} In`,
  starts: `Starts`,
  ends: `Ends`,
  list_of_winners: `LIST OF WINNERS`,
  days: `Days`,
  hours: `Hours`,
  minutes: `Minutes`,
  seconds: `Seconds`,
  total_amount_received: `Total Amount Received`,
  claim: `Claim`,
  requirement_to_withdraw: `Requirement to withdraw:`,
  total_bet_x: `Total Bet {{x}}`,
  x_of_y: `{{x}} of {{y}}`,
  no_balance: `No Balance`,
  fullname_note: `Ensure your full name matches your bank account to avoid withdrawal problems.`,
  number_exists: 'This phone number is already registered!',
  number_not_exists: 'This phone number is not registered!',
  payment_draft:
    'If you confirm you have already paid, please wait for a while as the payment might still be processing',
  live_chat: 'Live Chat',
  please_download_x_to_play: 'Download {{x}} and enjoyed exciting games',
  password: 'Password',
  play_now: 'Play Now',
  vip_benefits: 'VIP Benefits',
  no_limits: 'No Limits',
  no_limits_description:
    "We offer personal VIP services with unique gaming conditions to all players in the VIP club. Now you can play without any worries! It's very simple - play for the thrill, improve your gaming skills, enjoy your time and get no limits on your winnings opportunities!",
  financial_privileges: 'Financial Privileges',
  financial_privileges_description:
    "VIP club welcomes all players who want to get high-quality VIP service. Exclusive privileges, special promotions and benefits are available for you at our Website! VIP player's status unlocks higher withdrawal limits of funds in record-breaking short terms! Enjoy it!",
  personal_manager: 'Personal Manager',
  personal_manager_description:
    'Which of the advantages would you like to get when you become a VIP player? Share your thoughts with your personal manager and let us know what more you would be happy to see at our Website! We are always open for great suggestions!',
  vip_promotions: 'VIP Promotions',
  vip_promotions_description:
    'Would you like to get more great promotions, hefty VIP players enjoy all these and many more perks as a reward for the loyalty! Be on of them!',
  become_vip: 'Become A VIP',
  play_the_way_you_want: 'Play the way you want',
  join_vip_program: 'Join the VIP Programme Now!',
  join_now: 'Join Now',
  // TODO: Translate to other lang
  vip_club: 'VIP Club',
  withdraw_limit: 'Withdraw Limit',
  cashback: 'Cashback',
  personal_account_manager: 'Personal Account Manager',
  dont_show_again: "Don't show again",
  next: 'Next',
  close: 'Close',
  logout_confirmation: 'Logout Confirmation',
  are_you_sure_to_logout: 'Are you sure you want to logout?',
  // must_start_with: `Phone number must be atleast 10 digits & start with (valid network i.e. 96, 97, 98, 01)`,
  must_start_with: `Must start with (valid network i.e. 010, 011, 012, 013, 014, 015, 016, 017, 018, 019)`,
  see_all: 'See All',
  verified_by_play_protect: `Verified by Play Protect`,
  reviews: `26K reviews`,
  reviews_value: `4M+`,
  downloads: `Downloads`,
  rated_for: `Rated for 18+`,
  install: `Install`,
  add_to_wishlist: `Add to wishlist`,
  about_this_app: `About this app`,
  app_description_1: `Welcome to Jit993, Malaysia's premier online casino platform, where excitement and winning
              opportunities never stop! Whether you're a fan of classic casino games or modern, high-stakes betting, we
              offer something for everyone. Experience the thrill of our wide range of games, including slots,
              blackjack, roulette, poker, and more—all from the comfort of your mobile device.`,
  app_description_2: `At Jit993, we prioritize your safety and gaming experience. Our platform is fully licensed and secure,
              ensuring fair play and responsible gaming at all times. We use advanced technology to protect your
              personal information and provide a seamless gaming experience with fast deposits, quick withdrawals, and
              24/7 customer support.`,
  why_choose_brand: `Why choose Jit993?`,
  reason_1: `A vast selection of games from top game providers`,
  reason_2: `User-friendly interface with easy navigation`,
  reason_3: `Exclusive bonuses and promotions tailored just for you`,
  reason_4: `Secure payment options for fast and safe transactions`,
  reason_5: `Available in Malay and English to suit your preference`,
  app_description_3: `Join thousands of satisfied players today and take part in Malaysia's most trusted online casino
              experience! Whether you're here for the thrill of the game or the chance to win big, Jit993 is your
              gateway to endless entertainment.`,
  optional: 'Optional',
  app_download: `App Download`,
  download_message: `Download our app today!`,
  total_deposit_in_a_month: `Total Deposit in a Month`,
  acc_manager: `ACC Manager`,
  customer_service_priority: `Customer Service Priority`,
  deposit_withdraw_priority: `Deposit & Withdrawal Priority`,
  daily_withdraw_limit: `Daily Withdraw Limit`,
  transaction_counts: `Transaction Counts`,
  upgrade_bonus: `Upgrade Bonus (Lifetime)`,
  vip_birthday_bonus: `Birthday Bonus`,
  vip_loyalty_bonus_1: `VIP Loyalty Bonus`,
  vip_loyalty_bonus_2: `(offline reload/maintain bonus/monthly rewards)`,
  festival_gift: `Festival Gift`,
  invited_only: `By invitation`,
  normal: `Normal`,
  medium: `Medium`,
  high: `High`,
  hint: `Hint`,
  first_priority: `First Priority`,
  daily_rebate: `Daily Rebate %`,
  sports_cricket: `Sports / E-Sports / Cricket`,
  slots_fish_crash: `Slots / Fishing / Crash Game`,
  vip_maintenance_3_mo: `VIP Maintenance in 3 Months`,
  membership_renewal: `Membership Renewal`,
  month_x: `Month({{x}})`,
  lifetime: `Lifetime`,
  add_your_birthday: `Add your birthday`,
  edit_delete_bank_account: `Edit/Delete Bank Account`,
  opps: `Opps!`,
  delete_bank_account: `Delete Bank Account`,
  add_bank_account: `Add Bank Account`,
  please_select_lang: 'Please Select A Language',
  before_that: 'Before That',
  how_to_get_referral_bonus: 'How To Get Referral Friend Bonus?',
  steps_to_claim: 'Steps To Claim Bonus',
  confirm_logout: `Confirm Logout?`,
  currency: `Currency`,
  you_currently_unable: `You’re currently unable to remove/edit your bank account. Please contact our customer support for further assistance.`,
  country: `Country`,
  login_password: `Login Password`,
  uuid: `UUID`,
  change: 'Change',
  set_now: `Set Now`,
  share_your_referral_code:
    '1. Share your referral code to your friends to register account via Facebook, Twitter, or WhatsApp.',
  after_friend_register:
    '2. After friend register with Jit993, both referral and referral member required to make deposit to claim this bonus.',
  refer_a_friend_bonus: '3. Refer friend bonus calculation:',
  turnover_played: 'Turnover played x Commision % = Referral Friend Bonus',
  example: 'Example:',
  turnover_formula_x: 'Turnover (1,000,000) x 0.002% (Commission %) = 2,000{{x}}',
  note_bonus_only: '*Note: Bonus only able to claim on the next day after 12:00am',
  note_bonus_only_x: '*Note: Bonus only able to claim on the next day after {{x}}',
  access_dashboard: '4. Access dashboard to check entitled profit, commision tier, claim history, and downline.',
  click_this_button_to_claim: 'Click this button to claim Referral Friend Bonus',
  commision_tier: 'Commission Tier',
  member_downline: 'Member Downline',
  affiliates: 'Affiliates',
  you_can_reach_media_platforms: 'You can reach us through any of our social media platforms',
  no_data: 'No Data',
  total_deposit: `Total Deposit`,
  more_games: `More Games`,
  favorite_game: `Favorite Game`,
  bank_details: `Bank Details`,
  edit_profile: `Edit Profile`,
  total_balance: `Total Balance`,
  vip_center: `VIP Center`,
  join_community: `Join Our Community`,
  language: 'Language',
  preferred_bank: 'Preferred Bank',
  account_holder: `Account holder`,
  select_bank: `Select Bank`,
  eneter_here: `Enter here`,
  today: `Today`,
  all_type: `All Type`,
  no_record_found: `No Records Found`,
  yesterday: `Yesterday`,
  last_three_days: `Last 3 Days`,
  last_seven_days: `Last 7 Days`,
  last_15_days: `Last 15 Days`,
  last_30_days: `Last 30 Days`,
  date_time: `Date & Time`,
  transaction_id: `Transaction ID`,
  transaction_type: `Transaction Type`,
  successful: `Successful`,
  approve: `Approve`,
  completed: `Completed`,
  pending: `Pending`,
  failed: `Failed`,
  enter_here: `Enter here`,
  mobile: `Mobile`,
  enter_code: `Enter the code`,
  request_otp: `Request OTP`,
  continue: `Continue`,
  not_received_otp: `Not Received OTP?`,
  sending: `Sending...`,
  resend_in: `Resend in`,
  please_enter_new_password: `Please enter your new password`,
  password_contain: `The password must contain at least`,
  six_characters: `At least 6 characters`,
  contains_letters_numbers: `Contains a letter and number`,
  enter_new_password: `Enter new password`,
  confirm_new_password: `Confirm new password`,
  receipt: `Receipt`,
  important_notice: `Important Notice`,
  always_check_for_latest_active: `Always check for the latest active deposit bank details before making a deposit.`,
  depositors_name_must_match: `Depositor’s ACCOUNT NAME must match with registered full name. We do not encourage transaction made using 3rd party/company account.`,
  for_using_bank_transfer: `For using deposit option "Bank Transfer", Please make the transfer before submit the transaction to avoid the transaction is delay.`,
  please_do_not_fill_sensitive: `Please DO NOT fill any sensitive words related to gambling as reference/remark in your online transfer transaction.`,
  please_take_note: `Please take note that 1x turnover is required for all deposits made before any withdrawal can be processed.`,
  kindly_check_live_chat: `Kindly check with our 24/7 LIVECHAT if your transaction is pending for more than 5 minutes.`,
  min_amount: `Min amount`,
  minimum_deposit_is: `Minimum deposit is`,
  deposit_channel: `Deposit channel`,
  remember_password: `Remember Password`,
  enter_password: `Enter Password`,
  dont_you_have_account: `Don't have an account?`,
  create_account_now: `Create account now`,
  contact_number: `Contact Number`,
  enter_account_number: `Enter Account Number`,
  select_currency: `Select Currency`,
  i_agree_the: `I agree the`,
  terms_of_use: `Terms of use`,
  and: `and`,
  wallet_balance: `Wallet Balance`,
  others: `Others`,
  hot_news: `HOT NEWS`,
  total_earn: `Total Earn`,
  double_reward_checkin: `Double reward for continuous check-in for`,
  claim_now: `Claim Now`,
  check_in_history: `Check-in History`,
  no_history_yet: `No History Yet`,
  from_provider: `From Provider`,
  to_provider: `To Provider`,
  transfer_amount: `Transfer Amount`,
  available_amount: `Available Amount`,
  turnover_requirement: `Turnover Requirement`,
  promo_code: `Promo Code`,
  enter_your_promo_code: `Enter your promo code`,
  select_provider: `Select Provider`,
  phone_number_not_associated: `This phone number has not been associated with any account, please re-enter.`,
  old_password: `Old Password`,
  id: `ID`,
  how_to_deposit: `How to deposit?`,
  how_to_withdrawal: `How to withdrawal?`,
  how_to_top_up: `How to top up?`,
  how_to_add_homescreen: `How to add to homescreen?`,
  search_game_name: `Search game name`,
  please_enter_correct_username: `Please enter the correct Username`,
  please_enter_correct_password: `Please enter the correct Password`,
  enter_username: `Enter Username`,

  our_commitment: `Our Commitment`,
  our_commitment_desc: `We are committed to promoting responsible gaming and ensuring that our platform remains a safe, controlled, and enjoyable environment for all players. While gaming is intended to be a form of entertainment, we recognize the importance of helping users maintain healthy habits and control over their activities.`,
  play_responsibly: `Play Responsibly`,
  play_subtitle: `We encourage all players to:`,
  play_responsibly_desc1: `Treat gaming as a form of entertainment, not a source of income`,
  play_responsibly_desc2: `Set personal limits on time and spending`,
  play_responsibly_desc3: `Avoid chasing losses`,
  play_responsibly_desc4: `Take regular breaks during gameplay`,
  play_responsibly_desc5: `Only play with funds you can afford to lose`,
  underage_protection: `Underage Protection`,
  underage_protection_subtitle1: `Our platform strictly prohibits access to individuals under the age of 18 (or the legal age in your jurisdiction).`,
  underage_protection_subtitle2: 'We take active measures to prevent underage gaming, including:',
  underage_protection_desc1: `Identity verification procedures`,
  underage_protection_desc2: `Account monitoring`,
  underage_protection_desc3: `Immediate suspension of accounts found to be underage`,
  self_control_tools: `Self-Control Tools`,
  self_control_tools_subtitle1: `We provide various tools to help players manage their gaming habits, including:`,
  self_control_tools_desc1: `Deposit Limits`,
  self_control_tools_desc2: `Session time reminders`,
  self_control_tools_desc3: `Cooling-off periods`,
  self_control_tools_desc4: `Self-exclusion options`,
  self_control_tools_subtitle2: `Players who feel the need to take a break can contact our support team for assistance in activating these features.`,
  sign_of_problem_gaming: `Signs of Problem Gaming`,
  sign_of_problem_gaming_subtitle1: `If you notice any of the following behaviors, it may be time to take a step back:`,
  sign_of_problem_gaming_desc1: `Spending more money or time than intended`,
  sign_of_problem_gaming_desc2: `Borrowing money to gamble`,
  sign_of_problem_gaming_desc3: `Chasing losses continuously`,
  sign_of_problem_gaming_desc4: `Neglecting work, family, or responsibilities`,
  sign_of_problem_gaming_desc5: `Feeling stressed, anxious, or frustrated due to gaming`,
  sign_of_problem_gaming_subtitle2: `Recognizing these signs early is important.`,
  support_and_assistance: `Support and Assistance`,
  support_and_assistance_subtitle1: `If you or someone you know may be experiencing gambling-related issues, we strongly encourage seeking professional help. There are many organizations that provide confidential support and guidance.`,
  support_and_assistance_subtitle2: `You may consider contacting:`,
  support_and_assistance_desc1: `Local counseling services`,
  support_and_assistance_desc2: `Professional support organizations`,
  support_and_assistance_desc3: `National helplines in your country`,
  our_responsibility: `Our Responsibility`,
  our_responsibility_subtitle1: `We actively monitor player activity to detect unusual or potentially harmful behavior. Where necessary, we may:`,
  our_responsibility_desc1: `Provide guidance or warnings`,
  our_responsibility_desc2: `Suggest limits or breaks`,
  our_responsibility_desc3: `Temporarily restrict access to protect the player`,
  contact_us_responsible: `Temporarily restrict access to protect the player`,
  contact_us_subtitle: `If you need assistance or would like to activate any responsible gaming tools, please contact our support team. We are here to help you maintain a safe and enjoyable experience.`,

  by_accessing_our_platform: `By accessing and using our platform, you agree to comply with and be bound by these Terms & Conditions. If you do not agree, please refrain from using our services.`,
  we_reserve_rights: `We reserve the right to modify, update, or change these terms at any time without prior notice. Continued use of the platform constitutes acceptance of the updated terms.`,
  eligibility: `Eligibility`,
  eligibility_desc1: `Users must be at least 18 years old (or legal age in their jurisdiction).`,
  eligibility_desc2: `Users are responsible for ensuring that online gaming is legal in their country.`,
  eligibility_desc3: `We reserve the right to suspend or terminate accounts that do not meet eligibility requirements.`,
  account_responsibility: `Account Responsibility`,
  account_responsibility_desc1: `Users must provide accurate and complete information during registration.`,
  account_responsibility_desc2: `Each user is allowed only one account.`,
  account_responsibility_desc3: `Users are responsible for maintaining the confidentiality of their login credentials.`,
  account_responsibility_desc4: `Any activity under your account is considered your responsibility.`,
  deposit_withdrawal: `Deposit and Withdrawal`,
  deposit_withdrawal_desc1: `All deposits must be made using approved payment methods.`,
  deposit_withdrawal_desc2: `Withdrawals are subject to verification and compliance checks.`,
  deposit_withdrawal_desc3: `We reserve the right to delay or reject withdrawals if suspicious activity is detected.`,
  deposit_withdrawal_desc4: `Processing times may vary depending on payment providers.`,
  bonuses_promotions: `Bonuses and Promotions`,
  bonuses_promotions_desc1: `All bonuses, rewards, and promotions are subject to specific terms.`,
  bonuses_promotions_desc2: `Abuse of promotions (including multiple accounts or fraud) is strictly prohibited.`,
  bonuses_promotions_desc3: `We reserve the right to cancel bonuses and winnings obtained through misuse.`,
  fair_play_usage: `Fair Play and Usage`,
  fair_play_usage_desc1: `Players must use the platform in a fair and lawful manner.`,
  fair_play_usage_desc2: `Any attempt to manipulate games, exploit system errors, or engage in fraudulent activity is prohibited.`,
  fair_play_usage_desc3: `In the event of system errors, we reserve the right to void affected bets and winnings.`,
  multiple_accounts_ip_policy: `Multiple Accounts and IP Policy`,
  multiple_accounts_ip_policy_desc1: `Multiple accounts by the same user are strictly prohibited.`,
  multiple_accounts_ip_policy_desc2: `If multiple accounts are found to share the same IP address or show related activity, we reserve the right to:`,
  multiple_accounts_ip_policy_desc2_1: `Suspend or terminate the accounts`,
  multiple_accounts_ip_policy_desc2_2: `Cancel all winnings`,
  multiple_accounts_ip_policy_desc2_3: `Refund only the original deposit amount`,
  provider_game_issues: `Provider and Game Issues`,
  provider_game_issues_desc1: `Games are operated by third-party providers.`,
  provider_game_issues_desc2: `In the event of technical issues, errors, or discrepancies from providers, we reserve the right to:`,
  provider_game_issues_desc2_1: `Adjust balances accordingly`,
  provider_game_issues_desc2_2: `Void affected bets or winnings`,
  provider_game_issues_desc3: `Decisions made based on provider reports are final.`,
  account_suspension_termination: `Account Suspension and Termination`,
  account_suspension_termination_subtitle: `We reserve the right to suspend or permanently close accounts if:`,
  account_suspension_termination_desc1: `Terms & Conditions are violated`,
  account_suspension_termination_desc2: `Fraudulent or suspicious activity is detected`,
  account_suspension_termination_desc3: `Required verification is not completed`,
  limitation_of_liability: `Limitation of Liability`,
  limitation_of_liability_subtitle: `We are not liable for:`,
  limitation_of_liability_desc1: `Losses resulting from user negligence`,
  limitation_of_liability_desc2: `Technical issues beyond our control`,
  limitation_of_liability_desc3: `Delays caused by third-party services`,
  limitation_of_liability_subtitle2: `Use of the platform is at your own risk.`,
  malaysia: `Malaysia`,
  introduction: `Introduction`,
  introduction_subtitle1: `We are committed to protecting your privacy and ensuring that your personal information is handled in a safe and responsible manner. This Privacy Policy explains how we collect, use, store, and protect your information when you use our platform.`,
  introduction_subtitle2: `By accessing or using our services, you agree to the terms outlined in this Privacy Policy.`,
  information_we_collect: `Information We Collect`,
  information_we_collect_subtitle1: `We may collect the following types of information:`,
  information_we_collect_desc1: `Personal Information`,
  information_we_collect_desc1_1: `Name`,
  information_we_collect_desc1_2: `Email address`,
  information_we_collect_desc1_3: `Contact Details`,
  information_we_collect_desc1_4: `Date of Birth`,
  information_we_collect_desc1_5: `Payment Information`,
  information_we_collect_desc2: `Account Information`,
  information_we_collect_desc2_1: `Username and login credentials`,
  information_we_collect_desc2_2: `Transaction history (deposits and withdrawals)`,
  information_we_collect_desc2_3: `Gaming activity and preferences`,
  information_we_collect_desc3: `Technical Information`,
  information_we_collect_desc3_1: `IP address`,
  information_we_collect_desc3_2: `Device information`,
  information_we_collect_desc3_3: `Browser type`,
  information_cookies: `Cookies and usage data`,
  how_we_use_information: `How We Use Your Information`,
  how_we_use_information_subtitle1: `Your information may be used for the following purposes:`,
  how_we_use_information_desc1: `To create and manage your account`,
  how_we_use_information_desc2: `To process deposits and withdrawals`,
  how_we_use_information_desc3: `To provide customer support`,
  how_we_use_information_desc4: `To improve our platform and user experience`,
  how_we_use_information_desc5: `To detect and prevent fraud, abuse, or illegal activities`,
  how_we_use_information_desc6: `To To comply with legal and regulatory requirements`,
  sharing_of_information: `Sharing of Information`,
  sharing_of_information_subtitle1: `We do not sell your personal data. However, we may share your information with:`,
  sharing_of_information_desc1: `Service providers (payment processors, IT services)`,
  sharing_of_information_desc2: `Game providers for gameplay and transaction validation`,
  sharing_of_information_desc3: `Regulatory authorities if required by law`,
  sharing_of_information_desc4: `Fraud prevention agencies to protect against abuse`,
  sharing_of_information_subtitle2: `All third parties are required to handle your data securely.`,
  data_security: `Data Security`,
  data_security_subtitle1: `We implement advanced security measures to protect your information, including:`,
  data_security_desc1: `Encryption technologies `,
  data_security_desc2: `Secure servers and firewalls`,
  data_security_desc3: `Access control and monitoring systems`,
  data_security_subtitle2: `While we strive to protect your data, no system is completely secure. Users are responsible for keeping their login details confidential.`,
  cookie_policy: `Cookie Policy`,
  cookie_policy_subtitle1: `We use cookies and similar technologies to:`,
  cookie_policy_desc1: `Enhance user experience`,
  cookie_policy_desc2: `Remember preferences`,
  cookie_policy_desc3: `Analyze platform usage`,
  cookie_policy_subtitle2: `You may disable cookies through your browser settings, but some features of the platform may not function properly.`,
  data_retention: `Data Retention`,
  data_retention_subtitle1: `We retain your personal data only as long as necessary to:`,
  data_retention_desc1: `Fulfill the purposes outlined in this policy`,
  data_retention_desc2: `Comply with legal and regulatory obligations`,
  data_retention_subtitle2: `When data is no longer required, it will be securely deleted or anonymized.`,
  your_rights: `Your Rights`,
  your_rights_subtitle1: `Depending on your jurisdiction, you may have the right to:`,
  your_rights_desc1: `Access your personal data`,
  your_rights_desc2: `Request correction of inaccurate information`,
  your_rights_desc3: `Request deletion of your data`,
  your_rights_desc4: `Restrict or object to data processing`,
  your_rights_subtitle2: `To exercise these rights, please contact our support team.`,

  add_home_screen: 'Add to Home Screen',
  tap_share_button: 'Tap the share button',
  tap_add_home_screen: `Tap 'Add to Home Screen'`,
  tap_add: `Tap 'Add'`,
  for_quick_access: 'For Quick Access',
  add_to_home_screen: `Add to Home Screen`,
  step_one: `Step 1`,
  step_two: `Step 2`,
  step_three: `Step 3`,
  step_four: `Step 4`,

  top_casino: `Padu99`,
  play_big: `Main Padu, Menang Selalu.`,
  web: `WEB`,
  app_caps: `APP`,
  fast_caps: `FAST`,
  asia_biggest_most_trusted: `Padu99, Biggest And Most Trusted Platform. Partners With Saba Sports, Asia's No. 1 Brand Of Sports Market Leader, To Elevate Your Betting Journey!`,
  fast: `Fast`,
  seamless: `Seamless`,
  stay_updated: `Stay Updated`,
  smart_betting: `Smart Betting`,
  security: `Security`,
  live_streaming: `Live Streaming`,
  no_login_required: `No login is required after the first-time login to access Saba Sports app.`,
  deposit_and_withdraw_direct: `Deposit and withdraw directly through the app.`,
  receive_instant_notification: `Receive instant notifications for preferred games.`,
  access_valuable_information: `Access valuable information and statistics for smarter decisions.`,
  guarantees_data_transaction: `Guarantees data and transaction security with advanced features, fostering trust and providing highly secure transactions for players.`,
  live_watches: `Watch matches live within the app.`,

  dns_title: 'Set up public DNS',
  description_1:
    '1.1.1.1: Faster Internet is the preferred method of setting up 1.1.1.1 DNS Resolver in iOS and Android devices. It allows you to automatically configure your phone to use 1.1.1.1 on any network you connect to, and solves iOS and Android inability of using an alternative DNS Resolver in cellular connections.',
  description_2:
    'The App also allows you to enable encryption for DNS queries or enable WARP mode, which keeps all your HTTP traffic private and secure, including your DNS queries to 1.1.1.1.',
  description_3:
    "You can select between these two options in 1.1.1.1: Faster Internet's Settings. By default, 1.1.1.1: Faster Internet is configured to WARP mode. Set Up 1.1.1.1: Faster Internet",
  how_to_provide_faster_internet: 'How to Provide 1.1.1.1: Faster Internet',
  step1_title: 'Download',
  step1_desc: 'Download 1.1.1.1: Faster Internet from the App Store Or Google Play for free.',
  step2_title: 'Launch',
  step2_desc: 'Open 1.1.1.1: Faster Internet and accept the Terms of Service.',
  step3_title: 'Install',
  step3_desc: 'Install the VPN profile that allows your phone to connect securely to 1.1.1.1.',
  step4_title: 'Allow',
  step4_desc: 'Allow adding VPN configuration.',
  step5_title: 'Connect',
  step5_desc: 'Toggle the WARP button to Connected.',
  provider: 'Provider',
  withdrawal_amount: 'Withdrawal Amount',
  withdrawal_remaining: 'Withdrawal Remaining',
  selected_bank_details: `SELECTED BANK DETAILS`,
  withdraw_count: `Withdraw Count`,
  weekly_rebate: `Weekly Rebate`,
  tier_bonus_upgrade: `Tier Bonus Upgrade`,
  special_birthday_gift: `Special Birthday Gift`,
  upgrade_next_tier: `Upgrade to next tier`,
  maintenance_requirement: `Maintenance Requirement`,
  valid_until: `Valid Until`,
  unlimited: 'Unlimited',
  yes: 'Yes',
  months: 'Months',
  bronze: 'BRONZE',
  silver: 'SILVER',
  gold: 'GOLD',
  platinum: 'PLATINUM',
  diamond: 'DIAMOND',
  royal: 'ROYAL',

  about_us_welcome: `Welcome to Padu99 — your trusted destination for premium online gaming and entertainment.`,
  about_us_forward_thinking: `We are a forward-thinking online gaming company committed to delivering a world-class experience to players across the globe. Built on a foundation of innovation, reliability, and user satisfaction, our platform brings together a diverse selection of games, including slots, live casino, table games, and other interactive experiences powered by leading and reputable providers in the industry.`,
  about_us_goal: `Our goal is simple: to create an environment where players can enjoy seamless gameplay, exciting rewards, and complete peace of mind. We understand that trust is everything in online gaming, which is why we prioritize fairness, transparency, and security in every aspect of our operations. All games available on our platform are designed to meet strict standards, ensuring fair outcomes and a truly enjoyable experience.`,
  about_us_beyond_entertainment: `Beyond entertainment, we focus on delivering real value to our players. Through our comprehensive reward ecosystem — including deposit bonuses, loyalty points, daily check-in rewards, and lucky wheel promotions — we aim to maximize engagement while giving players more chances to benefit from their time on our platform. Every feature is carefully designed to enhance both enjoyment and reward potential.`,
  about_us_invest_technology: `We also invest heavily in technology to ensure that our platform remains fast, stable, and secure. From advanced encryption systems to robust backend infrastructure, we are dedicated to protecting user data and providing smooth, uninterrupted gameplay at all times.`,
  about_us_customer_satisfaction: `Customer satisfaction is at the heart of everything we do. Our professional support team is available to assist players promptly, addressing inquiries and resolving issues with efficiency and care. We believe that great service builds lasting relationships, and we are committed to supporting our players every step of the way.`,

  username_must_be: `Username must be between 6 to 20 characters`,
  fullname_must_be: `Full name can only consist of alphabetical characters and spaces`,
  fullname_required: `Full name is required`,
  password_must_be: `Password must be between 4 and 20 characters`,
  contact_number_must: `Contact No must start with 6 and follow by 10 or 11 digits`,
  account_number_required: `Account number is required`,

  agree_tnc: `You need to agree to the Terms of Use and Privacy Policy to login.`,
  i_agree: `I Agree`,
  send_code_mobile: ` We'll Send A Code To Your Mobile Number`,
  correct_code: `Please enter the correct code `,
  resend_code: `Resend Code`,
  resend_code_now: `Resend Code Now`,

  enter_valid_phone: `Please enter a valid phone number`,
  withdrawal_bank_account_name: `Withdrawal bank account name must match with registered full name.`,
  some_game_provider: `Some game provider requires 15 till 30 minutes of report sync time.`,
  please_make_sure_turn_over: `Please make sure your turnover requirement has been achieved.`,
  withdrawal_remaining_limit: `Withdrawal Remaining Limit`,

  select_promotion: `Select Promotion`,
  to_upgrade_to: `to upgrade to`,
  whatsapp: `Whatsapp`,
  marquee_announcement: `Play Strong, Win Always. Join Now — Hot Promotions, Fast Bonuses, And Unforgettable Gaming Experience Await You!`,
  no_withdraw_bank_account_yet: `No Withdrawal Account yet`,
  day: `Day`,
  processing: `Processing`,
  select_your_bank: `Select Your Bank`,
  add_bank_failed: `Add Bank failed`,
  add_bank: `Add Bank`,
  reject: `Reject`,
  in_progress: `In Progress`,
};

export default en;
